require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./blog-are-you-hiring-web-developers.json") })
        }
      }, "path---blog-are-you-hiring-web-developers");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---blog-are-you-hiring-web-developers!./.cache/json/blog-are-you-hiring-web-developers.json
// module id = 596
// module chunks = 231608221292675